<template>
  <div ref="mainElement" class="expression-rendered">
    <expression-input-node
      :node="tree.state.root"
      :level="0"
      display="inline"
      :editable="false"
      @click.prevent=""
    />
  </div>
</template>

<script setup lang="ts">
import { computed, provide, ref } from "vue";
import { useElementBounding } from "@vueuse/core";

import ExpressionInputNode from "./ExpressionInputNode.vue";

import { useExpressionTree } from "./ExpressionTree";
import { useTargetStore } from "../target/targets.store";
import { useIndexStore } from "../index/indices.store";
import { useResourceStore } from "../resource/resources.store";
import { useSettingsStore } from "@editor/store/settings.store";

import type { ExpressionParseContext } from "../effect/Expression";

const props = defineProps<{
  expression: string;
  parseContext: ExpressionParseContext;
}>();

const mainElement = ref<HTMLElement>();
const mainElementBounding = useElementBounding(mainElement);

const settings = useSettingsStore();

const targetStore = useTargetStore();
const indexStore = useIndexStore();
const resourceStore = useResourceStore();

const expressionParseContext = computed((): ExpressionParseContext => ({
  roundIndex: 0,
  targets: targetStore.items,
  indices: indexStore.items,
  resources: resourceStore.items,
  simulationSettings: {
    roundUnit: settings.simulationRoundUnit,
    roundLength: settings.simulationRoundLength,
    roundAmount: settings.simulationRoundAmount,
    timeStart: settings.simulationTimeStart,
    durationType: settings.simulationDurationType,
  },
  ...props.parseContext
}));

const tree = useExpressionTree(expressionParseContext, props.expression);

provide("parseContext", expressionParseContext);
provide("inputBounding", mainElementBounding);
provide("expressionTree", tree);
</script>